'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _validation = require('../utils/validation');

var _tracking = require('../utils/tracking');

var _customer = require('../services/customer');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var classes = {
  HIDE: 'util-Hide',
  BTN_LOADING: 'btn-Loading'
};

var tracking = {
  ACTION_SUBSCRIBE: 'Sign Up'
};

var init = exports.init = function init(_ref) {
  var onSubmit = function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(e) {
      var formData, customerEmail, tag, dob, redirect, response, eventJoinNewsletter;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e.preventDefault();
              hideValidationMessages();

              formData = new FormData(form);
              customerEmail = formData.get('customer_email');
              tag = formData.get('tag');
              dob = formData.get('customer_birthday');
              redirect = formData.get('redirect');

              if ((0, _validation.isValidEmail)(customerEmail)) {
                _context.next = 11;
                break;
              }

              els.validationError.classList.remove(classes.HIDE);
              _context.next = 21;
              break;

            case 11:
              if (!(dob && !(0, _validation.isValidDOB)(dob))) {
                _context.next = 15;
                break;
              }

              els.dobValidationError.classList.remove(classes.HIDE);
              _context.next = 21;
              break;

            case 15:
              els.submitButton.classList.add(classes.BTN_LOADING);

              _context.next = 18;
              return (0, _customer.newsletterSubscribe)({ customerEmail: customerEmail, tag: tag, dob: dob });

            case 18:
              response = _context.sent;

              els.submitButton.classList.remove(classes.BTN_LOADING);

              if (response.status === 200) {
                if (window.theme.isBHPreview) {
                  eventJoinNewsletter = new Event('join_newsletter');

                  eventJoinNewsletter.payload = {
                    customerEmail: customerEmail
                  };
                  document.dispatchEvent(eventJoinNewsletter);
                }

                (0, _tracking.trackGtag)({
                  eventCategory: initialState.trackingCategory,
                  eventAction: tracking.ACTION_SUBSCRIBE
                });

                els.validationSuccess.classList.remove(classes.HIDE);

                if (redirect) {
                  setTimeout(function () {
                    window.location = redirect;
                  }, 2000);
                }
              }

            case 21:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function onSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var form = _ref.el,
      context = _ref.context;

  var initialState = getInitialState(form);

  var els = getEls(context);

  setupForm();

  function setupForm() {
    if (els.checkbox) {
      els.checkbox.addEventListener('change', isCheckboxClicked);
    }

    form.addEventListener('submit', onSubmit);
  }

  function isCheckboxClicked() {
    if (els.checkbox.checked) {
      els.submitButton.disabled = false;
    } else {
      els.submitButton.disabled = true;
    }
  }

  function hideValidationMessages() {
    els.validationSuccess.classList.add(classes.HIDE);
    els.validationError.classList.add(classes.HIDE);
    if (els.dobValidationError) {
      els.dobValidationError.classList.add(classes.HIDE);
    }
  }
};

function getInitialState(el) {
  return {
    trackingCategory: el.dataset.trackingCategory
  };
}

function getEls(context) {
  return {
    submitButton: context.getElement('.' + context.className + '_SubmitButton'),
    checkbox: context.getElement('.' + context.className + '_Checkbox'),
    validationSuccess: context.getElement('.' + context.className + '_ValidationSuccess'),
    validationError: context.getElement('.' + context.className + '_ValidationError'),
    dobValidationError: context.getElement('.' + context.className + '_dobValidationError')
  };
}